module.exports = __webpack_public_path__ + "img/promo.6351414.jpg";